module.exports = __webpack_public_path__ + "static/fonts/notokr-regular.a288961.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/leader-seminar/font/notokr-regular.woff2
// module id = zKsU
// module chunks = 0